module.exports = __webpack_public_path__ + "static/img/2-1-3.1cbe53c9.png";